import * as React from "react";
import type { SVGProps } from "react";
const SvgSas = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <g fillRule="evenodd" clipRule="evenodd">
      <path
        fill="#0858a5"
        d="M2.063 46.603c0 .762.572 1.397 1.333 1.397h43.208c.761 0 1.396-.634 1.396-1.397V3.335C48 2.572 47.365 2 46.604 2H3.396A1.41 1.41 0 0 0 2 3.398z"
      />
      <path
        fill="#fefefe"
        d="M24.334 32.497h-3.047v-.063l3.997-5.146h.127l-1.015 5.21zm6.535-9.085h-3.87c-.191 0-.253.063-.253.063L16.022 36.818c-.064.064-.064.127.063.127h1.587c.126 0 .126 0 .19-.063l2.284-2.923s0-.064.063-.064h3.807s.063 0 .063.064c0 .063-.57 2.86-.57 2.86 0 .063 0 .126.19.126h4.568c.127 0 .127 0 .127-.063l2.601-13.344s.064-.126-.126-.126M5.68 35.294c-.063.126 0 .253.317.508.508.444 2.157 1.398 4.695 1.398 4.568 0 6.282-2.987 5.711-5.465-.19-.698-1.08-4.192-1.143-4.638-.38-1.461.318-2.478 1.65-2.478 1.206 0 1.904.444 2.539.826.126.063.19.126.253 0 0-.064.19-1.207.19-1.207s.063-.19-.19-.317c-.443-.255-1.46-.827-3.68-.827-4.123 0-5.9 2.67-5.139 5.528.19.89 1.142 4.32 1.142 5.019 0 .255.127 1.97-1.968 1.97-1.966 0-3.362-1.334-3.806-1.779-.064-.063-.19 0-.19.127-.063.126-.38 1.335-.38 1.335m24.364.063c-.063.127 0 .253.317.508.571.444 2.03 1.335 4.569 1.335 4.631 0 6.281-2.987 5.71-5.465-.19-.7-1.016-4.193-1.142-4.638-.38-1.461.316-2.478 1.649-2.478 1.206 0 1.903.445 2.538.826.127.063.19.127.253 0 0-.127.191-1.207.191-1.207s.063-.19-.19-.317c-.445-.255-1.46-.827-3.68-.827-4.124 0-5.9 2.668-5.14 5.528.19.89 1.143 4.32 1.143 5.019 0 .255.126 1.97-1.967 1.97-1.967 0-3.3-1.271-3.744-1.716-.126-.126-.253-.063-.253.064s-.254 1.398-.254 1.398"
      />
    </g>
  </svg>
);
export default SvgSas;
